import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from './ui/button';
import { Phone } from 'lucide-react';

/**
 * Reusable CTA Section Component
 * Used across service pages for consistent conversion opportunities
 */
const CTASection = ({ 
  title = "Ready to Get Started?",
  description = "Contact us today for a free quote",
  primaryButtonText = "Request Free Quote",
  primaryButtonLink = "/contact",
  showPhoneButton = true,
  phoneNumber = "321-408-1347",
  variant = "gradient" // 'gradient' | 'solid' | 'light'
}) => {
  const variantClasses = {
    gradient: "bg-gradient-to-r from-cyan-600 to-blue-700 text-white",
    solid: "bg-cyan-700 text-white",
    light: "bg-cyan-50 text-gray-900"
  };

  return (
    <section className={`py-20 px-4 sm:px-6 lg:px-8 ${variantClasses[variant]}`}>
      <div className="container mx-auto max-w-4xl text-center">
        <h2 className={`text-4xl md:text-5xl font-bold mb-6 ${variant === 'light' ? 'text-gray-900' : ''}`}>
          {title}
        </h2>
        <p className={`text-xl mb-8 ${variant === 'light' ? 'text-gray-600' : 'text-cyan-50'}`}>
          {description}
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center items-center">
          <Link to={primaryButtonLink}>
            <Button 
              size="lg" 
              className={`${variant === 'light' ? 'bg-cyan-600 text-white hover:bg-cyan-700' : 'bg-white text-cyan-600 hover:bg-gray-100'} text-lg px-8 py-6`}
            >
              {primaryButtonText}
            </Button>
          </Link>
          {showPhoneButton && (
            <a href={`tel:+1-${phoneNumber}`}>
              <Button 
                size="lg" 
                variant="outline" 
                className={`${variant === 'light' ? 'border-cyan-600 text-cyan-600 hover:bg-cyan-50' : 'border-white text-white hover:bg-white hover:text-cyan-600'} text-lg px-8 py-6`}
              >
                <Phone className="w-5 h-5 mr-2" />
                {phoneNumber}
              </Button>
            </a>
          )}
        </div>
      </div>
    </section>
  );
};

export default CTASection;
